import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loader-view",
  "use": "loader-view-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"loader-view\"><path d=\"M4.364.485a3.89 3.89 0 0 0-3.88 3.879 3.89 3.89 0 0 0 3.88 3.878 3.89 3.89 0 0 0 3.878-3.878A3.89 3.89 0 0 0 4.364.484Zm23.272 0a3.89 3.89 0 0 0-3.878 3.879 3.89 3.89 0 0 0 3.878 3.878 3.89 3.89 0 0 0 3.88-3.878 3.89 3.89 0 0 0-3.88-3.88ZM16 .485a3.89 3.89 0 0 0-3.879 3.879A3.89 3.89 0 0 0 16 8.242a3.89 3.89 0 0 0 3.879-3.878A3.89 3.89 0 0 0 16 .484Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol